import { Card, CardBody, Col } from "reactstrap";
import { Monthly, Schedules, Weekly, Yearly } from "../../../../utils/Constant";
import CommonCardHeader from "../../../../CommonElements/CommonCardHeader/CommonCardHeader";
import { onlineTimelineGroup, onlineTimelineItems } from "../../../../Data/Dashboard/Default/Default";
import Timeline from "react-calendar-timeline";
const Schedule = () => {
  return (
    <Col xl="4">
      <Card className="schedule">
        <CommonCardHeader headClass="pb-0" title={Schedules} mainTitle={true} firstItem={Weekly} secondItem={Monthly} thirdItem={Yearly} />
        <CardBody>
          <div className="timeline-calendar custom-scrollbar">
            <div className="custom-calendar" id="calendar-container">
              <div className="time-line" id="calendar">
                <Timeline groups={onlineTimelineGroup} items={onlineTimelineItems} defaultTimeStart={new Date().getTime()} defaultTimeEnd={new Date().setHours(new Date().getHours() + 4)} />
              </div>
            </div>
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default Schedule;
